import MessageTable from './MessageTable';

export default MessageTable;
